module.exports = __webpack_public_path__ + "static/img/popular-04.d3d5ea7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/popular-04.jpg
// module id = 2WJQ
// module chunks = 1